// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import axios from "axios";

// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const response = await axios.post(
//         // "http://localhost:3001/api/user/forgot-password",
//         { email }
//       );
//       const label = "login";
//       if (response.status === 200) {
//         toast.success("Password reset link sent to your email!");
//         navigate("/check-email", { state: { email, label } });
//       }
//     } catch (error) {
//       if (error.response) {
//         toast.error(error.response.data.message || "Error sending reset link");
//       } else {
//         toast.error("Network error. Please try again.");
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#fffdf7] flex items-center justify-center p-4">
//       <div className="max-w-md w-full bg-[#fcfaec] rounded-xl p-8 md:p-10 shadow-lg">
//         <h1 className="text-3xl font-bold text-black mb-6 text-center">
//           Forgot Password
//         </h1>
//         <p className="text-gray-600 mb-8 text-center">
//           Enter your email address and we'll send you an OTP to reset your
//           password.
//         </p>

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label
//               htmlFor="email"
//               className="block text-sm font-medium text-gray-700 mb-1"
//             >
//               Email Address
//             </label>
//             <input
//               type="email"
//               id="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-lime-400"
//               placeholder="Enter your registered email"
//               required
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={isLoading}
//             className={`w-full py-3 px-4 rounded-full font-bold text-white ${
//               isLoading ? "bg-gray-400" : "bg-lime-500 hover:bg-lime-600"
//             } transition duration-200`}
//           >
//             {isLoading ? (
//               <span className="flex items-center justify-center">
//                 <svg
//                   className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                 >
//                   <circle
//                     className="opacity-25"
//                     cx="12"
//                     cy="12"
//                     r="10"
//                     stroke="currentColor"
//                     strokeWidth="4"
//                   ></circle>
//                   <path
//                     className="opacity-75"
//                     fill="currentColor"
//                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                   ></path>
//                 </svg>
//                 Sending...
//               </span>
//             ) : (
//               "Send Reset Link"
//             )}
//           </button>
//         </form>

//         <div className="mt-6 text-center">
//           <button
//             onClick={() => navigate("/login")}
//             className="text-lime-600 hover:text-lime-800 font-medium"
//           >
//             Back to Login
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await api.post("/password/forgot-password", null, {
        params: { email },
      });

      if (response.data.success) {
        toast.success("OTP sent to your email!");
        navigate("/reset-password", { state: { email } });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error sending OTP");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fffdf7] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#fcfaec] rounded-xl p-8 md:p-10 shadow-lg">
        <h1 className="text-3xl font-bold text-black mb-6 text-center">
          Forgot Password
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Enter your email address and we'll send you an OTP to reset your
          password.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-lime-400"
              placeholder="Enter your registered email"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-3 px-4 rounded-full font-bold text-white ${
              isLoading ? "bg-gray-400" : "bg-lime-500 hover:bg-lime-600"
            } transition duration-200`}
          >
            {isLoading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-lime-600 hover:text-lime-800 font-medium"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
